// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { userStoreActions as actions } from '.';

// function* doSomething() {}

export function* userStoreSaga() {
  // yield takeLatest(actions.someAction.type, doSomething);
}
